import { Component, Input, AfterViewInit, OnChanges } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-bug-pie-chart',
  templateUrl: './bug-pie-chart.component.html',
  styleUrls: ['./bug-pie-chart.component.scss']
})
export class BugPieChartComponent implements AfterViewInit, OnChanges {

  @Input() data: any[] = [];   // [{module:"Phase 1", bug_count:4}]
  @Input() id: string = "";
  @Input() Title: string = "Pie Chart";
  @Input() labelKey: string = 'module';
  @Input() valueKey: string = 'bug_count';

  chart: any;

  ngAfterViewInit() {
    this.render();
  }

  ngOnChanges() {
    this.render();
  }

  render() {
    if (!this.data || this.data.length == 0) return;

    setTimeout(() => {
      const canvas: any = document.getElementById("canvas_" + this.id);
      if (!canvas) return;

      const ctx = canvas.getContext("2d");

      if (this.chart) this.chart.destroy();

      // FIX: Extract clean labels + values dynamically
      const labels = this.data.map(x => x[this.labelKey] || "Unspecified");
      const values = this.data.map(x => x[this.valueKey] || 0);

      this.chart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: labels, // MUST be simple text
          datasets: [{
            data: values,
            backgroundColor: ['#104358', '#1369A3', '#469BD3', '#74A3C3'],
          }]
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'right',
              labels: {
                usePointStyle: true,
                pointStyle: 'rect',
                font: { size: 12 },
                padding: 20
              }
            },
            title: {
              display: false
            }
          }
        }
      });

    }, 50);
  }
}
